import React
from 'react';
import { Alert } from 'react-bootstrap';
import { HHIEButton } from '../../utility/HHIEButton';

export const FalsePasswordReset = () => {
    return (
        <Alert variant="danger">
            This functionality has not been implemented. Please <HHIEButton id="return-home-btn" title="Return Home" onClick={() => {window.location.href = "/";}}/>
        </Alert>
    );
}